module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs notes-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        累计" + _vm._s(_vm.page.total) + "次合同订单\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "size": "small",
      "type": "daterange",
      "unlink-panels": "",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间"
    },
    on: {
      "change": _vm.datepicker
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "item-list"
  }, [(!_vm.tableData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('li', {
      staticClass: "item",
      class: {
        'hc-red': item.isRed
      }
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.addTime))]), _vm._v(" "), _c('div', {
      staticClass: "order"
    }, [_c('div', {
      staticClass: "id"
    }, [_c('i', {
      staticClass: "ico green"
    }, [_vm._v("单")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.id, item.isRed)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.id, item.isRed)
        }
      }
    }, [_vm._v(_vm._s(item.contractNo))])]), _vm._v(" "), _c('div', {
      staticClass: "good"
    }, [_c('span', {
      staticClass: "thumb"
    }, [_c('img', {
      attrs: {
        "src": item.productImg,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.productKind) + "种商品 共" + _vm._s(item.productNum) + "件")]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(item.amount))])]), _vm._v(" "), _c('div', {
      staticClass: "response"
    }, [_vm._v("负责人：" + _vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.statusStr))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n        加载更多\n      ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.size) ? [_vm._v("没有更多")] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-831958f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/customer/customer-contract.vue
// module id = 1313
// module chunks = 82